module.exports = require('../package.json').version;



//////////////////
// WEBPACK FOOTER
// ./~/websocket/lib/version.js
// module id = d0sq
// module chunks = 29